import React from 'react';

const COLORS = ['#1a56db', '#059669', '#d97706', '#dc2626', '#7c3aed', '#0891b2', '#be185d', '#4f46e5', '#15803d', '#b45309'];

function getColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return COLORS[Math.abs(hash) % COLORS.length];
}

function getInitials(name) {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return parts[0][0].toUpperCase();
}

export default function Avatar({ name, size = 28, fontSize }) {
  const color = getColor(name || '');
  const fs = fontSize || Math.round(size * 0.42);
  return (
    <span style={{
      width: size, height: size, minWidth: size, borderRadius: '50%',
      background: color + '18', color: color,
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      fontSize: fs, fontWeight: 700, lineHeight: 1, flexShrink: 0,
      border: `1.5px solid ${color}30`
    }}>
      {getInitials(name)}
    </span>
  );
}
